<template>
  <div class="codemirror" style="height:90vh;text-align:left;">
    <div class="">
      <a href="#!" @click="$emit('toview')">View</a><br>
      <a ref="savebutton" style="" class="btn savebutton" @click="savePost">
        <i class="material-icons">save</i>
        <span style="margin-left:3px;transform:translate(0px,-4px);display:inline-block;">Save</span>
      </a>
      <a style="" class="btn red" @click="delPost">
        <i class="material-icons">delete</i>
        <span style="margin-left:3px;transform:translate(0px,-4px);display:inline-block;">Del</span>
      </a>
      <a style="" class="btn" @click="copyPost">
          <i class="material-icons">file_copy</i>
          <span style="margin-left:3px;transform:translate(0px,-4px);display:inline-block;">Copy</span>
      </a>
      <!-- <br>
      <br> -->
      Title:<br>
      <!-- <h3 ref="title" style="border-bottom:1px solid grey;" contenteditable="true">{{ title }}</h3> -->
      <input type="text" ref="title" v-model="title"/>
      <div class="input-field inline">
          <input id="email_inline" type="number" class="validate" 
              @input="fontSize = $event.target.value">
          <label for="email_inline">FontSize</label>
      </div>
      <!-- <div v-if="code != null"> -->
    </div>


    <!-- <codemirror ref="cm" style="text-align:left;font-size:12px;" v-model="code" :options="cmOption"></codemirror> -->
    
    <table style="width:100%;table-layout:fixed;" v-if="true">
      <tr>
        <td style="max-width:48vh;min-width:48vh;overflow:hidden;vertical-align:top;">
          <codemirror ref="cm" style="text-align:left;font-size:12px;" v-model="code" :options="cmOption"></codemirror>
        </td>
        <td :style="`max-width:48vh;min-width:48vh;vertical-align:top;max-height:95vh;overflow-y:scroll;padding-left:5px;
          font-size: ${fontSize}px;`">
          <MKRender ref="mk" :source="code2"/>
          <!-- <div ref="mdshow" class="markdownshow" :style="`font-size: ${fontSize}px;`">
            <vue-markdown :source="code" :show="true" :postrender="mdPost"></vue-markdown> 
          </div> -->
        </td>
      </tr>
    </table>

    <!-- </div> -->

  <!-- or to manually control the datasynchronization（或者手动控制数据流，需要像这样手动监听changed事件） -->
  <!--<codemirror ref="myCm"
              :value="code" 
              :options="cmOptions"
              @ready="onCmReady"
              @focus="onCmFocus"
              @input="onCmCodeChange">
  </codemirror>-->
  </div>
</template>
<script>
import MKRender from '../MKRender/main'

  // language

  // theme css
  //import 'codemirror/theme/base16-dark.css'
  //import 'codemirror/theme/solarized.css'
  import 'codemirror/theme/monokai.css'
  import 'codemirror/mode/python/python.js'
  import 'codemirror/mode/markdown/markdown.js'
  import 'codemirror/mode/yaml/yaml.js'


  // active-line.js
  import 'codemirror/addon/selection/active-line.js'

  // styleSelectedText
  import 'codemirror/addon/selection/mark-selection.js'
  import 'codemirror/addon/search/searchcursor.js'

  // highlightSelectionMatches
  import 'codemirror/addon/scroll/annotatescrollbar.js'
  import 'codemirror/addon/search/matchesonscrollbar.js'
  import 'codemirror/addon/search/searchcursor.js'
  import 'codemirror/addon/search/match-highlighter.js'

  // keyMap
  import 'codemirror/mode/clike/clike.js'
  import 'codemirror/addon/edit/matchbrackets.js'
  import 'codemirror/addon/comment/comment.js'
  import 'codemirror/addon/dialog/dialog.js'
  import 'codemirror/addon/dialog/dialog.css'
  import 'codemirror/addon/search/searchcursor.js'
  import 'codemirror/addon/search/search.js'
  import 'codemirror/keymap/sublime.js'
  import 'codemirror/keymap/vim.js'

  // foldGutter
  import 'codemirror/addon/fold/foldgutter.css'
  import 'codemirror/addon/fold/brace-fold.js'
  import 'codemirror/addon/fold/comment-fold.js'
  import 'codemirror/addon/fold/foldcode.js'
  import 'codemirror/addon/fold/foldgutter.js'
  import 'codemirror/addon/fold/indent-fold.js'
  import 'codemirror/addon/fold/markdown-fold.js'
  import 'codemirror/addon/fold/xml-fold.js'
  import 'codemirror/addon/edit/continuelist.js'


import _ from 'lodash'

//https://stackoverflow.com/questions/4009756/how-to-count-string-occurrence-in-string
function occurrences(string, subString, allowOverlapping) {

    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
        pos = 0,
        step = allowOverlapping ? 1 : subString.length;

    while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
            ++n;
            pos += step;
        } else break;
    }
    return n;
}

function betterTab(cm) {
  if (cm.somethingSelected()) {
    cm.indentSelection("add");
  } else {
    cm.replaceSelection(cm.getOption("indentWithTabs")? "\t":
      Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");
  }
}
  export default {
    props: ['treeObj'],
    components: {
      MKRender,
    },
    data() {
      return {
        code: '',
        code2: '',
        title: '',
        fontSize: 18,
        firstLoad: true,
        cmOption: {
          tabSize: 2,
          foldGutter: true,
          autoCloseBrackets: true,
          // styleActiveLine: true,
          lineNumbers: true,
          // line: true,
          // smartIndent: true,
          // eletricChars: true,
          keyMap: "vim",
          //mode: 'text/x-vue',
          //mode: 'text/x-csrc',
          // mode: 'text/x-python',
          mode: 'markdown',
          //theme: 'base16-dark',
          //theme: 'solarized light',
          theme: 'monokai',
          extraKeys: {
            'F11'(cm) {
              cm.setOption("fullScreen", !cm.getOption("fullScreen"))
            },
            // Tab: betterTab
            Tab: "indentMore",
            'Shift-Tab': "indentLess",
            "Enter": "newlineAndIndentContinueMarkdownList",
            'F9': function(cm) {
              cm.replaceSelection('```\n\n```') 
            },
            'F8': function(cm) {
              // cm.replaceSelection('```\n\n```') 
              const cursor = cm.getCursor()
              const pos = {
                line: cursor.line,
                ch: cursor.ch,
              }
              let linecontent = cm.getValue().split("\n")[cursor.line]
              let prefix = ''
              let linecontentup = cm.getValue().split("\n")[cursor.line-1]
              // console.log('line content', linecontent)
              let m = linecontent.match(/^.*?-/)
              let suffix = '\n'
              if (m){
                suffix = `\n${m[0].slice(0,m[0].length-1)}  crash_grid 5\n  ${m[0]} `
              }
              cm.replaceRange(suffix, pos)

              setTimeout(() => {
                document.querySelector('.CodeMirror-hscrollbar').scrollLeft = 0
                document.querySelector('.CodeMirror-vscrollbar').scrollTop = 
                  document.querySelector('.CodeMirror-vscrollbar').scrollTop + 40
              }, 100)
            },
            'F7': function(cm) {
              // cm.replaceSelection('```\n\n```') 
              const cursor = cm.getCursor()
              const pos = {
                line: cursor.line,
                ch: cursor.ch,
              }
              let linecontent = cm.getValue().split("\n")[cursor.line]
              let prefix = ''
              let linecontentup = cm.getValue().split("\n")[cursor.line-1]
              // console.log('line content', linecontent)
              let m = linecontent.match(/^.*?-/)
              let suffix = '\n'
              if (m){
                suffix = `\n${m[0].slice(0,m[0].length-1)}  `
              }
              cm.replaceRange(suffix, pos)
            },
            //'Esc'(cm) {
            //  if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
            //}
          }
        }
      }
    },
    beforeMount(){
      this.title = this.treeObj.title
      this.code = this.treeObj.content
      this.code2 = this.treeObj.content
        // console.log('notedetail', this.noteSelected)
        // if (!this.noteSelected.key) {
        //   this.title = this.noteSelected.title
        //   this.code = ''
        //   return
        // }
        // this.axios.get('http://automation:9000/get/crashcode2/'+this.noteSelected.key).then(rs => {
        //     console.log(rs.data)
        //     this.title = rs.data.title.trim()
        //     this.code = rs.data.body
        //     this.code2 = rs.data.body
        // })
    },
    methods: {
      copyPost(){
        this.copyToClipboard(this.code)
      },
      delPost(){
        if(confirm('are you sure? delete?') === true){
          this.$emit('delFile')
        }
      },
      savePost(){
        let oldtitle = this.treeObj.title
        // this.treeObj.title = this.$refs.title.innerHTML // using old h3 contenteditable
        this.treeObj.title = this.$refs.title.value
        this.treeObj.content = this.code
        this.$emit('saveFile', {
          title: this.$refs.title.value,
          oldtitle,
          content: this.code
        })
        // const payload = {
        //   key: this.noteSelected.key,
        //   title: this.$refs.title.innerHTML,
        //   body: this.code, 
        // }
        // this.axios.post('http://automation:9000/post/crashcode2', payload).then(rs => {
        //   this.noteSelected.key = rs.data.key
        //   this.noteSelected.title = rs.data.title
        //   this.send_toast('Save ok', 'ok')
        // }).catch(err => {
        //   this.send_toast(err, 'err')
        // })
      },
      mdPost(e){
        console.log('post', e)
        const regexp = new RegExp('<img.*alt="(.*?)"[^/]*\/>', 'gm')
        let match
        while ((match = regexp.exec(e)) !== null) {
          console.log('m', match)
          if (match[1]){
            let [w,h] = match[1].split('x')
            let rep = ''
            if (w)
              rep += ` width="${w}px" `
            if (h)
              rep += ` height="${h}px" `
            
            e = e.replace(match[0], match[0].replace('/>', rep + ' />'))
          }
        }
        return e
      },
      mdRendered: _.debounce(function(e){
        console.log('inside mdrendered', this.$refs.mdshow)
        if (this.$refs.mdshow){
          this.$refs.mdshow.querySelectorAll('img').forEach(elem => {
            console.log(elem)
            let alt = elem.getAttribute('alt')
            if (alt.includes('x')){
              let [w,h] = alt.split('x')
              w && elem.setAttribute('width', w+'px')
              h && elem.setAttribute('height', h+'px')
            }
          })

        }
      }, 300),
      bodyHook(value){
        console.log('value', value)
        const payload = {
          key: '<genserial>',
          value: value,
        }
        this.axios.post(this.$apiprefix+'/post/'+this.$imgcol, payload).then(rs => {
          const cm = this.$refs.cm.codemirror
          //window.cm = cm
          const cursor = cm.getCursor()
          const pos = {
            line: cursor.line,
            ch: cursor.ch,
          }
          let linecontent = cm.getValue().split("\n")[cursor.line]
          let prefix = ''
          let linecontentup = cm.getValue().split("\n")[cursor.line-1]
          console.log(`lc> line content   : "${linecontent}"`)
          console.log(`lc> line content up: "${linecontentup}"`)
          let linehascontent = linecontent.match(/^[ ]*-[ ]+\w*/)
          let lineuphascontent = linecontentup.match(/^[ ]*-[ ]+\w*/)
          console.log(`lc> linehascontent  : "${linehascontent}"`)
          console.log(`lc> lineuphascontent: "${lineuphascontent}"`)
          let m = linecontent.match(/^.*?-/)
          let mup = linecontentup.match(/^.*?-/)
          console.log('lc> m', m)
          let suffix = '\n'
          if (linehascontent){
            console.log(`lc> linecontent.trim(): "${linecontent.trim()}"`)
            if (linecontent.trim() == '-'){
              prefix = ''
            }else{
              prefix = `\n${m[0].slice(0, m[0].length-1)}  `
            }
            suffix = `\n${m[0]} `
            // if (lineuphascontent){
            //   suffix = `\n${mup[0].slice(0, mup[0].length-1)}  - `
            // }
          }else{
            if (lineuphascontent){
              let mup2 = linecontentup.match(/^\s+?-/)
              let cur_line_space = linecontent.match(/^[ ]+/)
              if (cur_line_space){
                if (linecontent.trim().length == 0){
                  prefix = ``
                }else{
                  prefix = `\n${cur_line_space}`
                }
              }
              if (mup2){
                suffix = `\n${mup2[0]} `
              }
            }else{
              let cur_line_space = linecontent.match(/^[ ]+/)
              console.log('lc>>', linecontent, linecontentup)
              console.log('lc>> cur_line_space', cur_line_space)
              if (cur_line_space){
                if (linecontent.trim().length > 0){
                  prefix = `\n${cur_line_space}`
                }
                suffix = `\n${cur_line_space}`
              }else{
                if (linecontent.length > 0){
                  prefix = `\n`
                }
                suffix = "\n"
              }
            }
          }
          // if (linecontent.trim() != '-' && prefix == ''){ // not only "-" in line
          //   prefix = '\n'
          // }
          console.log(`lc> prefix:"${prefix.replaceAll("\n", "nl")}" suffix:"${suffix.replaceAll("\n", "nl")}"`)
          cm.replaceRange(`${prefix}![](${this.$apiprefix}/get/${this.$imgcol}/${rs.data.key}?rt=img)${suffix}`, pos)
          this.savePost()
          setTimeout(() => {
            document.querySelector('.CodeMirror-vscrollbar').scrollTop = 
              document.querySelector('.CodeMirror-vscrollbar').scrollTop + (20*(1+occurrences(prefix+suffix, "\n")))
          }, 100)
        })
      },
      foo(){
        console.log(this.$refs.cm)
        const cm = this.$refs.cm.codemirror
        cm.replaceRange('asdfasdf', cm.Pos(cm.lastLine()))
      },
      switchAction(){
        this.action = this.action == 'To Markdown'
                        ? 'To Code'
                        : 'To Markdown'
      },
      onCmCursorActivity(codemirror) {
        //console.log('onCmCursorActivity', codemirror)
      },
      onCmReady(codemirror) {
        //console.log('onCmReady', codemirror)
      },
      onCmFocus(codemirror) {
        //console.log('onCmFocus', codemirror)
      },
      onCmBlur(codemirror) {
        //console.log('onCmBlur', codemirror)
      },
      saveCode: _.debounce((obj) => {
          //console.log('saving code', code)
          // this.code2 = obj.code
          console.log('obj', obj)
          obj.code2 = obj.code
          return
          if (obj.firstLoad){
            obj.firstLoad = false
            return
          }
          if (obj.code == null) return
          let doc = {
              'path': obj.$route.path,
              'doc': obj.code
          }
        //   obj.axios.put('http://docker:7777', doc)
      }, 800),
      loadData(path = null){
          if (this.$route.path == '/') return

          let doc = {
              'path': (path == null) ? this.$route.path : path
          }
          this.code = null
        //   this.axios.post('http://docker:7777', doc).then((rs) => {
        //       //console.log('load data', rs.data)
        //       this.firstLoad = true
        //       this.code = rs.data.body
        //   })
      }
    },
    mounted(){
        //  __     ___                          
        //  \ \   / (_)_ __ ___      ___      __
        //   \ \ / /| | '_ ` _ \    (_) \ /\ / /
        //    \ V / | | | | | | |    _ \ V  V / 
        //     \_/  |_|_| |_| |_|___(_) \_/\_/  
        //                     |_____|          
        const cm = this.$refs.cm
        window.cm = cm
        cm.codemirror.save = () => {
          this.savePost()
        }



        //   _               _       _                 _    
        //  | |__   ___   __| |_   _| |__   ___   ___ | | __
        //  | '_ \ / _ \ / _` | | | | '_ \ / _ \ / _ \| |/ /
        //  | |_) | (_) | (_| | |_| | | | | (_) | (_) |   < 
        //  |_.__/ \___/ \__,_|\__, |_| |_|\___/ \___/|_|\_\
        //                     |___/                        
        window.bodyHook = this.bodyHook 
        // this.loadData()

        //       _   _      _       _                         _ _ _             
        //   ___| |_(_) ___| | __  | |_ ___  _ __     ___  __| (_) |_ ___  _ __ 
        //  / __| __| |/ __| |/ /  | __/ _ \| '_ \   / _ \/ _` | | __/ _ \| '__|
        //  \__ \ |_| | (__|   <   | || (_) | |_) | |  __/ (_| | | || (_) | |   
        //  |___/\__|_|\___|_|\_\___\__\___/| .__/___\___|\__,_|_|\__\___/|_|   
        //                     |_____|      |_| |_____|                         
        const obj = this
        const mk = this.$refs.mk.$el
        window.addEventListener('scroll', (e) => {
          // console.log('obj', obj.$refs.cm)
          // console.log(mk.getBoundingClientRect())
          // console.log(obj.$refs)
          let sb = obj.$refs.savebutton
          let cm = obj.$refs.cm.$el
          let bb = cm.getBoundingClientRect()
          // console.log('sb', sb)
          // console.log('---', bb.top, mk.getBoundingClientRect().top)
          if (!window.bb){
            window.bb = bb
          }
          if (bb.top < 0) {
            cm.style.position = 'fixed'
            cm.style.top = '10px'
            cm.style.width = bb.width+'px'

            sb.style.position = 'fixed'
            sb.style.bottom = '0px'
            sb.style.left = '0px'
          }else if (bb.top < mk.getBoundingClientRect().top){
            cm.style.position = 'inherit'
            cm.style.top = '10px'

            sb.style.position = 'inherit'
            sb.style.bottom = null 
            sb.style.left = null
            // cm.style.width = bb.width+'px'
          }
          // console.log('scroll', e, bb)
        })
    },
    watch: {
        $route(to, from) {
        //   this.loadData(to.path)
        },
        code: function (newval, oldval){
          //console.log('newval', newval, oldval)
          console.log('code change')
          if (oldval && newval != oldval){
            document.querySelectorAll('.savebutton').forEach(b => {
                b.classList.add('orange')
            })
          }
          this.saveCode(this)
            //console.log('changed')
            // this.saveCode(this)
        }
    }
  }
</script>


<style>
.CodeMirror {
    height:80vh !important;
}

.markdownshow ul {
    list-style-type: circle !important;
}
.markdownshow ul:not(.browser-default) {
	/* padding-left: 30px; */
	/* margin-top: 10px; */
	/* margin-bottom: 15px; */
    margin-left:10px;
}

.markdownshow ul:not(.browser-default) li {
    list-style-type: disc;
}
ul > li {
    margin-left: 10px;
}
</style>
